// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"Dashboard_mainContainer__23SzL","leftContainer":"Dashboard_leftContainer__2wMaT","rightContainer":"Dashboard_rightContainer__1Asb6"};